module.exports = __webpack_public_path__ + "media/images/home/focus_card-89868ba491d3c02643603301dbdebe3f.jpeg";